import React from 'react';
import { List, Brain, ChefHat, ArrowRight } from 'lucide-react';

const HowItWorks = ({ language }) => {
  const texts = {
    en: {
      title: 'How It Works',
      subtitle: 'Three simple steps to delicious custom recipes',
      steps: [
        {
          number: '01',
          icon: List,
          title: 'Snap a Photo',
          description: 'Take a photo of the ingredients you have in your kitchen - our AI does the rest'
        },
        {
          number: '02',
          icon: Brain,
          title: 'AI Analysis',
          description: 'Our smart AI instantly recognizes ingredients and creates customized recipes just for you'
        },
        {
          number: '03',
          icon: ChefHat,
          title: 'Get Cooking',
          description: 'Receive personalized recipes with step-by-step instructions ready to prepare'
        }
      ]
    },
    pt: {
      title: 'Como Funciona',
      subtitle: 'Três passos simples para receitas deliciosas e personalizadas',
      steps: [
        {
          number: '01',
          icon: List,
          title: 'Tire uma Foto',
          description: 'Tire uma foto dos ingredientes que você tem em sua cozinha - nossa IA faz o resto'
        },
        {
          number: '02',
          icon: Brain,
          title: 'Análise por IA',
          description: 'Nossa IA inteligente reconhece instantaneamente os ingredientes e cria receitas personalizadas para você'
        },
        {
          number: '03',
          icon: ChefHat,
          title: 'Comece a Cozinhar',
          description: 'Receba receitas personalizadas com instruções passo a passo prontas para preparar'
        }
      ]
    }
  };

  const t = texts[language];

  return (
    <section id="section-3" className="py-20 bg-gradient-to-br from-green-50 to-emerald-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="relative">
          {/* Connection lines for desktop */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-green-200 transform -translate-y-1/2 z-0"></div>
          
          <div className="grid lg:grid-cols-3 gap-8 relative z-10">
            {t.steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-8">
                  <div className="w-24 h-24 bg-white rounded-full shadow-lg flex items-center justify-center mx-auto mb-4 relative z-10">
                    <step.icon className="w-10 h-10 text-green-600" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    {step.number}
                  </div>
                </div>
                
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {step.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Demo Image */}
        <div className="mt-16 text-center">
          <div className="relative inline-block">
              <img
                src="/images/phone-camera-ingredients.jpg"
                alt={language === 'en' ? 'Phone camera capturing ingredients' : 'Câmera do telefone capturando ingredientes'}
                className="w-full max-w-md rounded-2xl shadow-2xl"
              />
            <div className="absolute -bottom-4 -right-4 bg-green-600 text-white px-4 py-2 rounded-full text-sm font-medium">
              {language === 'en' ? 'AI in Action' : 'IA em Ação'}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
